<div class="image-dialog">
    <div class="preview-section">
        <div class="dialog-header">
            <h6> Preview Files</h6>
        </div>

        <div class="dialog-body">
            <!-- File Preview Section -->
            <div *ngIf="previewFiles.length === 0" class="message"> No files uploaded. Please select files to upload.
            </div>

            <div *ngIf="previewFiles.length && !existingdata.isDisbursment" class="preview-section-scroll">
                <div class="files-list-preview" *ngFor="let file of previewFiles; let i = index">
                    <div class="file-item">
                        <div class="file-content">
                            <mat-icon>image</mat-icon>
                            <div class="file-info">
                                <div class="file-name">{{ file.name }}</div>
                            </div>
                            <div class="description">
                                <span placeholder="Add description..."
                                    style="font-size: 14px;">{{file.description}}</span>
                            </div>
                        </div>
                        <button type="button" (click)="preview(file, 'preview')" class="preview-btn"
                            [disabled]="!canPreview(file,'preview' )">
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <button type="button" (click)="downloadFile(file)" class="download-btn">
                            <mat-icon>download</mat-icon>
                        </button>
                        <button type="button" class="sync-btn" [ngClass]="{'blue': file.sync === 'Y'}">
                            <mat-icon>sync</mat-icon>
                        </button>

                        <button type="button" (click)="deleteSelectedFile(file)" class="remove-btn">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- if the disbursement, show PDA and FDA sections -->
            <div *ngIf="previewFiles.length && existingdata.isDisbursment">
                <div class="preview-container">
                    <!-- Part 1: Show first half of the files -->
                    <span style="margin-bottom: 10px;">PDA</span>
                    <div *ngIf="pdaPreviewFiles.length" class="preview-pda-part">
                        <div *ngFor="let file of pdaPreviewFiles" class="file-item">
                            <div class="file-content">
                                <mat-icon>image</mat-icon>
                                <div class="file-info">
                                    <div class="file-name">{{ file.name }}</div>
                                </div>
                                <div class="description">
                                    <span placeholder="Add description..." style="font-size: 14px;">{{ file.description
                                        }}</span>
                                </div>
                            </div>
                            <button type="button" (click)="preview(file, 'preview')" class="preview-btn"
                                [disabled]="!canPreview(file, 'preview')">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button type="button" (click)="downloadFile(file)" class="download-btn">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button type="button" (click)="deleteSelectedFile(file)" class="remove-btn">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div *ngIf="pdaPreviewFiles.length === 0" class="message" style="margin-bottom: 10px;"> No files
                        uploaded For PDA. Please select
                        files to upload.
                    </div>
                    <mat-divider style="margin-top: 10px;margin-bottom: 10px;"></mat-divider>
                    <!-- Part 2: Show second half of the files -->
                    <span style="margin-bottom: 10px;">FDA</span>
                    <div class="preview-fda-part">
                        <div *ngFor="let file of fdaPreviewFiles" class="file-item">
                            <div class="file-content">
                                <mat-icon>image</mat-icon>
                                <div class="file-info">
                                    <div class="file-name">{{ file.name }}</div>
                                </div>
                                <div class="description">
                                    <span placeholder="Add description..." style="font-size: 14px;">{{ file.description
                                        }}</span>
                                </div>
                            </div>
                            <button type="button" (click)="preview(file, 'preview')" class="preview-btn"
                                [disabled]="!canPreview(file, 'preview')">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button type="button" (click)="downloadFile(file)" class="download-btn">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button type="button" (click)="deleteSelectedFile(file)" class="remove-btn">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="fdaPreviewFiles.length === 0" class="message"> No files uploaded For FDA. Please select
                        files to upload.
                    </div>


                </div>
            </div>


        </div>
    </div>
    <!-- <div class="container">
        <mat-divider [vertical]="true"></mat-divider>

    </div> -->

    <div class="image-section">
        <div class="dialog-header">
            <h6> Upload Files</h6>
            <mat-form-field appearance="outline" style="width: 180px;" *ngIf="existingdata.isDisbursment">
                <mat-label>Select PDA or FDA</mat-label>
                <mat-select [formControl]="fileUploadFor">
                    <mat-option value="PDA">PDA</mat-option>
                    <mat-option value="FDA">FDA</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-icon-button class="close-icon" (click)="closeDialog()" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="dialog-body">
            <!-- File Upload Section -->
            <div class="upload-section">
                <div class="upload-card" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                    [ngClass]="{'disabled-section': isDisabled}">

                    <div *ngIf="isLoading" class="loading">
                        <mat-icon class="spin">refresh</mat-icon>
                        <span>Uploading...</span>
                    </div>

                    <div *ngIf="!isLoading" class="upload-area">
                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                        <p>Drag and drop files here or</p>
                        <input type="file" #fileInput (change)="onFileSelected($event)" [accept]="allowedTypes" multiple
                            hidden [disabled]="isDisabled">
                        <button type="button" (click)="fileInput.click()" class="choose-btn"
                            [disabled]="isDisabled">Choose Files</button>
                    </div>

                    <!-- <div *ngIf="errorMessage" class="error" role="alert">
                        <mat-icon>error</mat-icon>
                        <span>{{ errorMessage }}</span>
                    </div> -->

                    <div *ngIf="successMessage" class="success" role="alert">
                        <mat-icon>check_circle</mat-icon>
                        <span>{{ successMessage }}</span>
                    </div>
                </div>
                <small class="info">
                    Supported: PDF, JPG, PNG, DOCX, XLSX (Max: {{ maxFileSizeMB }}MB each, File name length ≤ 50
                    characters) </small>
            </div>

            <!-- File Preview Section -->
            <form [formGroup]="fileUploadForm" (ngSubmit)="upload()">
                <div formArrayName="files" *ngIf="selectedFiles.length && !isLoading" class="upload-preview-scroll">
                    <div *ngFor="let file of selectedFiles; let i = index" [formGroupName]="i" class="file-item">
                        <div class="file-content">
                            <mat-icon>image</mat-icon>
                            <div class="file-info">
                                <div class="file-name">{{ file.name }}</div>
                            </div>

                            <!-- Bind the description input field to the corresponding FormControl -->
                            <div class="description">
                                <textarea placeholder="Add description..." cdkTextareaAutosize
                                    formControlName="description"></textarea>
                            </div>
                        </div>

                        <button type="button" (click)="preview(file,'upload' )" class="preview-btn"
                            [disabled]="!canPreview(file,'upload')">
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <button *ngIf="isUploadMode" type="button" (click)="removeFile(i)" class="remove-btn">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </form>

        </div>
        <!-- Footer Actions -->
        <div *ngIf="selectedFiles.length && !isLoading" class="dialog-footer">
            <button type="button" (click)="upload()" class="btn upload">
                <mat-icon>upload</mat-icon>Upload
            </button>
            <button type="button" (click)="cancel()" class="btn cancel">
                <mat-icon>cancel</mat-icon>Clear All
            </button>
        </div>
    </div>
</div>